<template>
  <div v-if="showings">
    <div class="listing-showings-block" v-for="(next, index) in showings.slice(0, 2)" :key="`listing-${index}`">
      <div class="time" v-if="nextShowing(next)">
        <span v-if="longerVersion">Kohteessa {{ showingTypeText(next) }}</span>
        <span v-else>{{ $filters.capitalizeFirstLetter(showingTypeText(next)) }}</span>
        {{ getWeekday(next.startTimestamp) }}
        <span class="no-wrap">{{ next.date }}</span>
        <span class="no-wrap">klo. {{ `${next.startTime} - ${next.endTime}` }}</span>
        .
      </div>
      <div v-if="longerVersion && nextShowing(next)" class="calendar-link">
        <a
          v-if="!!baseInfo && baseInfo.location && showAddCalendarLink"
          class="calendar-link"
          :href="googleLink(next)"
          target="_blank"
        >
          Lisää kalenteriin
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import config from '@/config';
import { genGoogleCalendarLink } from '@/app/common/calendar-link-generator';
import { DateTime } from 'luxon';
import { defineComponent, type PropType } from 'vue';

export default defineComponent({
  name: 'showings',
  props: {
    longerVersion: {
      type: Boolean,
      default: false,
    },
    showings: {
      type: Array as PropType<any[]>,
      required: true,
    },
    showAddCalendarLink: {
      type: Boolean,
      default: false,
    },
    baseInfo: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    currentUrl: '',
  }),
  mounted() {
    this.currentUrl = window.location.href;
  },
  methods: {
    googleLink(showing: any) {
      return genGoogleCalendarLink(showing, this.baseInfo?.location, this.currentUrl);
    },
    getWeekday(timestamp: string) {
      return timestamp && new Date(timestamp) ? config.weekdays[new Date(timestamp).getDay()] : '';
    },
    showingTypeText(showings: any) {
      const showingType = showings.firstShowing ? 'ensiesittely' : 'esittely';
      return showingType;
    },
    nextShowing(showing: any) {
      const nextShowing = showing;
      if (!nextShowing) {
        return null;
      }
      const showingEndTime = DateTime.fromISO(nextShowing.endTimestamp);
      return DateTime.now() < showingEndTime ? nextShowing : null;
    },
  },
});
</script>
